export const getControllerUrl = (site, locale, path, params = {}) => {
    const localeId = locale.replace('-', '_')
    const origin = window.location.origin
    const baseUrl = `${origin}/on/demandware.store/Sites-${site}-Site/${localeId}/${path}`
    const queryString = new URLSearchParams(params).toString()
    return queryString ? `${baseUrl}?${queryString}` : baseUrl
}
